export default "__VITE_ASSET__BQtTCDu7__"